import React, {useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './daily.css'
import {Table} from 'react-bootstrap'

const ListItem = (props:any) =>{
    useEffect(()=>{
      window.scroll(0,0)
    },[])
    const { item } =
    (props.location && props.location.state) || {};
    console.log(item)

    return (
        <div className="App">
            <div className="daily">
                <h4>基本信息</h4>
                <Table striped bordered hover>
                    <tbody>
                    <tr>
                        <td>权属单位</td>
                        <td>{item.company.org_name}</td>
                    </tr>
                    <tr>
                        <td>境外机构</td>
                        <td>{item.org.org_name}</td>
                    </tr>
                    <tr>
                        <td>派出在册职工数量</td>
                        <td>{item.people_1}</td>
                    </tr>
                    <tr>
                        <td>劳务派遣员工数量</td>
                        <td>{item.people_2}</td>
                    </tr>
                    <tr>
                        <td>国内分包商员工数量</td>
                        <td>{item.people_3}</td>
                    </tr>
                    <tr>
                        <td>外方雇员数量</td>
                        <td>{item.people_4}</td>
                    </tr>

                    <tr>
                        <td>当日返回 <b>境内</b> 员数量</td>
                        <td>{item.return_1}</td>
                    </tr>
                    <tr>
                        <td>当日返回 <b>项目</b> 人员数量</td>
                        <td>{item.return_3}</td>
                    </tr>
                    <tr>
                        <td>本月返回 <b>境内</b> 人员数量</td>
                        <td>{item.return_2}</td>
                    </tr>
                    <tr>
                        <td>本月返回 <b>项目</b> 人员数量</td>
                        <td>{item.return_4}</td>
                    </tr>
                    <tr>
                        <td>返回境内人员隔离情况</td>
                        <td>{item.return_status}</td>
                    </tr>
                    </tbody>
                </Table>
                <h4>防疫物资储备数量</h4>
                <Table striped bordered hover>
                    <tbody>
                    <tr>
                        <td>医用口罩</td>
                        <td>{item.goods_1}</td>
                    </tr>
                    <tr>
                        <td>N95口罩</td>
                        <td>{item.goods_10}</td>
                    </tr>
                    <tr>
                        <td>消毒液（L)</td>
                        <td>{item.goods_2}</td>
                    </tr>
                    <tr>
                        <td>防护服（套）</td>
                        <td>{item.goods_3}</td>
                    </tr>
                    <tr>
                        <td>护目镜（副）</td>
                        <td>{item.goods_4}</td>
                    </tr>


                    </tbody>
                </Table>
                <h4>防疫药品储备数量</h4>
                <Table striped bordered hover>
                    <tbody>

                    <tr>
                        <td>连花清瘟（盒）</td>
                        <td>{item.goods_5}</td>
                    </tr>
                    <tr>
                        <td>阿比多尔（盒）</td>
                        <td>{item.goods_6}</td>
                    </tr>
                    <tr>
                        <td>是否出现疑似、确诊病例</td>
                        <td>{item.suspected === '1' ? '是' :'否'}</td>
                    </tr>
                    </tbody>
                </Table>

                <h4>防疫设备储备数量</h4>
                <Table striped bordered hover>
                    <tbody>

                    <tr>
                        <td>血氧仪（个）</td>
                        <td>{item.goods_9}</td>
                    </tr>
                    <tr>
                        <td>体温计（个）</td>
                        <td>{item.goods_11}</td>
                    </tr>
                    <tr>
                        <td>呼吸机（个）</td>
                        <td>{item.goods_12}</td>
                    </tr>
                    <tr>
                        <td>制氧机（个）</td>
                        <td>{item.goods_13}</td>
                    </tr>
                    </tbody>
                </Table>


            </div>
        </div>
    );
}

export default ListItem;
